module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "ebook-toc-2",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("Chapter 1")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame t",
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph t ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("friends")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("How to keep friend hangouts to a  reasonable amount (and still keep your friends)")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 t2"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "alt": "",
      "src": "image/Friends_Chapter_spread.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph t ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Good friends will understand your  introverted ways, so the escapes and excuses  in this chapter should be used carefully!")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Oh, that tricky balance between  sweet alone time and seeing people you like.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 t"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/Friends_Chapter_spread1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Scenario 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-13"
  }, [_vm._v("Friends who love Trivia Night and want you to come with them")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 t2"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Friends__2_Scenario_trivia_night.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("“I already made plans with "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "alt": "",
      "src": "image/underline.png"
    }
  }), _vm._v("               .”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 r2"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "5em"
    },
    attrs: {
      "alt": "",
      "src": "image/arrow_3_purple.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 r2"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "6em"
    },
    attrs: {
      "alt": "",
      "src": "image/tip.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph r ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-15"
  }, [_vm._v("Use the name of"), _c('br'), _vm._v(" any respectable "), _c('br'), _vm._v("family member.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1l"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "alt": "",
      "src": "image/Friends__2_Escape_plans_with_mom.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb r4",
    attrs: {
      "id": "_idContainer038"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Use partner's name, child's"), _c('br'), _vm._v(" name, pet's name, etc.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 r4"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "alt": "",
      "src": "image/arrow_3_purple1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("“ "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "alt": "",
      "src": "image/underline1.png"
    }
  }), _vm._v("                has been feeling neglected lately.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 t2"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "5em"
    },
    attrs: {
      "alt": "",
      "src": "image/tip.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer035"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-15"
  }, [_vm._v("This is more likely to"), _c('br'), _vm._v(" be understood by people with pets, "), _c('br'), _vm._v("children, or needy partners.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 r0"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "alt": "",
      "src": "image/Friends__2_Escape_neglected.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer040"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Compromise by going once.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("Make sure to answer quickly and incorrectly a couple  of times to reduce frequency of future invitations")]), _c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer039"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/4.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer042"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Scenario 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer043"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-13"
  }, [_vm._v("A rambunctious dinner party  with too many people")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 t2"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer041"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/Friends__1_Scenario_dinner_party.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer045"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Become preoccupied playing with the animals.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer044"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "alt": "",
      "src": "image/Friends__1_Escape_pets.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer047"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "alt": "",
      "src": "image/tip1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer046"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-15"
  }, [_vm._v("Always keep an emergency supply of treats in your bag.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer049"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Speak quietly and murmur to encourage  the surrender of the conversation.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("After they give up or resort to smiling and nodding,  you can probably say whatever you want.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer048"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/5.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer050"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/6.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer051"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Keep asking questions that  require long responses.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("It means less speaking time for you.  You’re probably already a good listener anyway.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer053"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Scenario 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer054"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-13"
  }, [_vm._v("hangouts are always  big group activities")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 t2"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer052"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "alt": "",
      "src": "image/Friends__3_Scenario_shift_large_group_activities.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer055"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/Friends__3_Escape_reschedule.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer057"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("“I can’t tonight. Could we reschedule to a  craft night on")]), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "8em"
    },
    attrs: {
      "alt": "",
      "src": "image/underline2.png"
    }
  }), _c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("                           ?”")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 r"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer062"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "5em"
    },
    attrs: {
      "alt": "",
      "src": "image/arrow_3_purple2.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame r",
    attrs: {
      "id": "_idContainer061"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "alt": "",
      "src": "image/tip2.jpg"
    }
  }), _c('span', {
    staticClass: "CharOverride-15"
  }, [_vm._v("You should actually"), _c('br'), _vm._v("  follow through on this"), _c('br'), _vm._v(" if you like this friend.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer058"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('img', {
    staticClass: "floatl",
    staticStyle: {
      "width": "7em"
    },
    attrs: {
      "alt": "",
      "src": "image/Friends__3_Escape_reschedule1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-15"
  }, [_vm._v("Bonus points if you suggest an introvert-friendly activity.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb clear",
    attrs: {
      "id": "_idContainer064"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("If you must go, locate another  introvert in the group.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("Become absorbed in a quiet conversation with them,  as per usual introvert style.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer063"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/7.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer066"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Suggest very specific activities  for future hangouts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("Pick ones that you think only one  or two friends might take you up on.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer065"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/8.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer068"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Scenario 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer069"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-13"
  }, [_vm._v("A phone call from someone you  genuinely like but don’t want to  talk on the phone to")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 t2"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer067"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/Friends__4_Scenario_receiving_phone_call.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer071"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("“I’m actually expecting a call  from   "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "alt": "",
      "src": "image/underline3.png"
    }
  }), _vm._v("                .”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v(" Fill in with anything that sounds official or important. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 t"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer074"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "5em"
    },
    attrs: {
      "alt": "",
      "src": "image/tip.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer073"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-15"
  }, [_vm._v("Offer a replacement for the  phone conversation, perhaps by  inviting this person over soon.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer070"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Friends__4_Escape_expecting_call_from.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer075"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Friends__4_Escape_battery_dying.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer076"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("“Whoops, I think my battery  is about to die.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("Kindly wrap up the conversation and be careful not to imply for them to try again later.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer078"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Answer the phone in a whisper  and say, “   "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "5em"
    },
    attrs: {
      "alt": "",
      "src": "image/underline4.png"
    }
  }), _vm._v("             is napping.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v(" Suggest a quiet alternative like texting. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 t2"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer079"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "alt": "",
      "src": "image/tip.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer081"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-15"
  }, [_vm._v("Use your roommate's name, pet's name, etc.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer077"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Friends__4_Escape_answer_phone_in_whisper.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer084"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Scenario 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer085"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-13"
  }, [_vm._v("A game night that is lasting  longer than you’d like")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 t"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer083"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "alt": "",
      "src": "image/Friends__5_Scenario_hosting_game_night.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer087"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Bribe a confidant to stealthily  flip the circuit breaker.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v(" Do not be prepared with candles.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer086"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Friends__5_Escape_circuit_breaker.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer089"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Turn off the music very pointedly  at the desired time.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer088"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Friends__5_Escape_turn_music_off.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer091"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Start the yawning train.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 t"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer090"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Friends__5_Escape_yawning_train.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer093"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Scenario 6")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer094"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-13"
  }, [_vm._v("Not enough alone time while  living with an outgoing roommate")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 t"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer092"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/Friends__6_Scenario_living_with_outgoing_roommate.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer095"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/Friends__6_Escape_morning_or_night_person.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer096"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Take note of whether they’re a  morning or night person. Be the opposite.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer097"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "alt": "",
      "src": "image/Friends__6_Escape_food_and_drinks.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer098"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("When they want to invite people over,  offer to make food or drinks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("Tasks like this can keep you busy to avoid dreaded small talk.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer100"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Schedule weekly dates to spend  organized, quality time together.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("Feel less guilty for all the other days you keep to yourself.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer099"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "alt": "",
      "src": "image/Friends__6_Escape_quality_time.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f8d3ee7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EscapeManualIntroverts_kindle_epub1.vue
// module id = 60
// module chunks = 0